import { render, staticRenderFns } from "./AproveRefuse.vue?vue&type=template&id=410b37b8&"
import script from "./AproveRefuse.vue?vue&type=script&lang=js&"
export * from "./AproveRefuse.vue?vue&type=script&lang=js&"
import style0 from "./AproveRefuse.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports